export default "__VITE_ASSET__DmZmMdgq__"